module.exports = flarum.extensions['v17development-seo'];